import { render, staticRenderFns } from "./ExportStudentGroups.vue?vue&type=template&id=2d863f7c&"
import script from "./ExportStudentGroups.vue?vue&type=script&lang=js&"
export * from "./ExportStudentGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports